import React from 'react'
import marked from 'marked'
import { Helmet } from 'react-helmet'
import { PageProps, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { HomePage as HomePageType } from '../typings'
import { Layout } from '../components/Layout'
import { Hero } from '../components/Hero'
import { Buttons } from '../components/Button'
import { Card } from '../components/Card'
import { Carousel, Slide } from '../components/Carousel'

interface HomePageProps {
  strapiHomepage: HomePageType
}

const HomePage = ({ data }: PageProps<HomePageProps>) => {
  const { hero, infoSlides } = data.strapiHomepage

  return (
    <Layout>
      <Helmet>
        <html lang="de" />
        <meta charSet="utf-8" />
        <meta name="description" content={hero.description} />
        <title>meinApoVerlag</title>
        <script>{`
          window.fwSettings = {
            widget_id: 201000002112
          };
          !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}() 
        `}</script>
        <script type="text/javascript" src="https://euc-widget.freshworks.com/widgets/201000002112.js" async defer></script>
      </Helmet>
      <Hero>
        <div className="max-w-2xl -mt-32 flex flex-col items-center">
          <h1 className="text-2xl lg:text-3xl text-center font-bold mb-4">{hero.title}</h1>
          <p className="text-lg lg:text-xl text-center">{hero.description}</p>
          {hero.buttons?.length && (
            <div className="flex flex-col md:flex-row md:justify-center md:flex-wrap gap-2 md:gap-4 mt-8">
              <Buttons buttons={hero.buttons} className="sm:w-60" />
            </div>
          )}
        </div>
      </Hero>
      <div className="mb-8 sm:mb-12 md:mb-16 lg:mb-20 space-y-8 sm:space-y-12 md:space-y-16 lg:space-y-20">
        {infoSlides?.length && (
          <Card className="lg:h-112 w-full md:w-screen-sm lg:w-screen-md mx-auto -mt-32 relative z-50">
            <Carousel dots>
              {infoSlides.map((slide) => {
                const image = getImage(slide.image?.localFile)
                return (
                  <Slide
                    key={slide.id}
                    title={slide.name}
                    className="flex flex-col md:flex-row items-center md:justify-center gap-4 md:gap-8"
                  >
                    {image && <GatsbyImage className="rounded-md shadow-md md:flex-1" image={image} alt={slide.name} />}
                    <div className="md:flex-1">
                      <div
                        className="markdown md:text-lg text-gray-600 leading-snug"
                        dangerouslySetInnerHTML={{ __html: marked(slide.content) }}
                      />
                    </div>
                  </Slide>
                )
              })}
            </Carousel>
          </Card>
        )}
      </div>
    </Layout>
  )
}

export default HomePage

export const query = graphql`
  query {
    strapiHomepage {
      id
      hero {
        title
        description
        buttons {
          id
          text
          url
          type
        }
      }
      infoSlides {
        id
        name
        content
        image {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 350, aspectRatio: 1.5)
            }
          }
        }
      }
    }
  }
`
